import { render, staticRenderFns } from "./BasicFilterItem.vue?vue&type=template&id=c8144eba"
import script from "./BasicFilterItem.vue?vue&type=script&lang=js"
export * from "./BasicFilterItem.vue?vue&type=script&lang=js"
import style0 from "./BasicFilterItem.vue?vue&type=style&index=0&id=c8144eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports